import alna from './alna';
import bjerke from './bjerke';
import frogner from './frogner';
import gamleoslo from './gamle_oslo';
import grorud from './grorud';
import grunerlokka from './grunerlokka';
import nordreaker from './nordre_aker';
import nordstrand from './nordstrand';
import oslo from './oslo';
import ostensjo from './ostensjo';
import sagene from './sagene';
import sondrenordstrand from './sondre_nordstrand';
import sthanshaugen from './st_hanshaugen';
import stovner from './stovner';
import ullern from './ullern';
import vestreaker from './vestre_aker';

export default {
  alna,
  bjerke,
  frogner,
  gamleoslo,
  grorud,
  grunerlokka,
  nordreaker,
  nordstrand,
  oslo,
  ostensjo,
  sagene,
  sondrenordstrand,
  sthanshaugen,
  stovner,
  ullern,
  vestreaker,
};
